<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (faxFileType of faxFileTypes | async; track trackBy(faxFileType)) {
      <lcs-option [value]="faxFileType" id="lcs-option-id-{{ faxFileType.faxFileTypeId }}">
         {{ faxFileType.faxFileTypeId }}
      </lcs-option>
      }
   </div>
</ng-template>
